import { Navigate, useLocation } from 'react-router-dom';
import { useIsAuthenticated } from '../shared/hooks/useAuth';

/**
 * Route guard — redirects unauthenticated users to /login.
 * Preserves the attempted URL in state.from for post-login redirect.
 */
export function ProtectedRoute({ children }: { children: JSX.Element }): JSX.Element {
  const isAuthed = useIsAuthenticated();
  const location = useLocation();

  if (!isAuthed) {
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  }

  return children;
}
